module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-events-subevents/boxoffice-events-subevents.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-events-subevents/boxoffice-events-subevents.component.scss
// module chunks = 9